// Vendor libs
import React, { useState, useEffect, useCallback } from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";

// Components & Utils
import { axios, host } from "../api/Api";
import InvoicesApi from "../api/Invoices";
import DownloadInvoiceModal from "../components/DownloadInvoiceModal";
import { formatMoney } from "../utils/Helpers";
import { useGlobalValue } from "../utils/GlobalState";
import { setIsLoading, setErrors } from "../utils/Actions";

export default function Invoices() {
  const [, dispatch] = useGlobalValue();
  const currentMonth = moment().month();
  const [invoices, setInvoices] = useState([]);
  const [startDate, setStartDate] = useState(moment().date(1).month(currentMonth - 6));
  const [endDate, setEndDate] = useState(moment());
  const modalDefault = {
    show: false,
    url: ""
  };
  const [downloadModal, setDownloadModal] = useState(modalDefault);

  const listInvoices = useCallback(() => {
    setIsLoading(true, dispatch);

    if (!startDate.isValid() || !endDate.isValid()) {
        setIsLoading(false, dispatch);
        return;
    }

    InvoicesApi.getInvoices(startDate, endDate)
      .then(response => {
        setIsLoading(false, dispatch);
        setInvoices(response);
      })
      .catch(apiErrors => {
        setErrors(apiErrors, dispatch);
        setIsLoading(false, dispatch);
      });
  }, [dispatch, startDate, endDate])

  // On Load: Get invoices
  useEffect(listInvoices, [listInvoices]);

  // Print Invoice Action
  const printInvoice = invoice_id => {
    setIsLoading(true, dispatch);

    axios
      .post("https://reports.polixen.com/phantom", {
        host: host[0],
        path: "/api/invoices/print",
        data: {
          invoiceId: invoice_id,
          hideBottom: true,
          print_all: false
        }
      })
      .then(response => {
        setIsLoading(false, dispatch);
        setDownloadModal({
          show: true,
          url: response.data.report
        });
      })
      .catch(apiErrors => {
        setErrors(apiErrors, dispatch);
        setIsLoading(false, dispatch);
      });
  };

  return (
    <div>
      <div className="row">
        <div className="col-12">
          <div className="d-sm-flex align-items-center justify-content-between my-4">
            <h4>Client Invoices</h4>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <div className="card-title text-bold"><b>List of Invoices</b></div>
              <div className="card-subtitle mb-3">List of past invoices made with the possibility to print them.</div>
              <div className="row mb-3 align-items-end">
                <div className="col-md-3 offset-md-3">
                  <label className="form-label">Start Date</label>
                  <input type="date" className="form-control text-center" value={startDate.format("YYYY-MM-DD")} onChange={e => setStartDate(moment(e.target.value, "YYYY-MM-DD"))}/>              
                </div>
                <div className="col-md-3">
                  <label className="form-label">End Date</label>
                  <input type="date" className="form-control text-center" value={endDate.format("YYYY-MM-DD")} onChange={e => setEndDate(moment(e.target.value, "YYYY-MM-DD"))}/>
                </div>
              </div>
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th style={{ width: 80 }}>#</th>
                    <th>Date</th>
                    <th>Total</th>
                    <th style={{ width: 40 }} className="text-center">
                      <FontAwesomeIcon icon={faPrint} />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {invoices.map(invoice => (
                    <tr key={invoice.id}>
                      <td>{invoice.id}</td>
                      <td>{moment(invoice.issue_date, "YYYY-MM-DD HH:mm:ss").format("Do MMMM YYYY")}</td>
                      <td>{formatMoney(invoice.total)}</td>
                      <td>
                        <button className="btn btn-sm btn-primary btn-block" onClick={() => printInvoice(invoice.id)}>
                          <FontAwesomeIcon icon={faPrint} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <DownloadInvoiceModal
        show={downloadModal.show}
        hide={() => setDownloadModal(modalDefault)}
        url={downloadModal.url}
      />
    </div>
  );
}
